var PROJ = (typeof PROJ === 'object') ? PROJ : {};
PROJ.pdp = {
    VAR: {},

    updateCartDetails: function (form, variantId) {
        if (!form || !variantId) return;
        var id = String(variantId);

        ['.pdp-sub-details', '.pdp-ot-details'].forEach(function (sel) {
            var panel = form.querySelector(sel);
            if (!panel) return;

            var variants = panel.querySelectorAll('.pdp-cart-details__variant');
            if (!variants.length) {
                panel.hidden = !panel.querySelector('.sub-image');
                return;
            }

            var matched = false;
            variants.forEach(function (el) {
                var isMatch = String(el.getAttribute('data-variant-id')) === id;
                el.hidden = !isMatch;
                if (isMatch) matched = true;
            });

            panel.hidden = !matched && !panel.querySelector('.sub-image');
        });
    },

    updateSubBenefitsFromPlan: function (form, planId) {
        if (!form || !planId) return;
        var benefits = form.querySelector('.pdp-sub-details .pdp-cart-details__variant:not([hidden]) .js-sub-benefits')
            || form.querySelector('.pdp-sub-details .js-sub-benefits');
        if (!benefits) return;

        var plans = {};
        try {
            plans = JSON.parse(benefits.getAttribute('data-plans') || '{}');
        } catch (e) {
            return;
        }

        var plan = plans[String(planId)];
        if (!plan) return;

        var saveEl = benefits.querySelector('[data-sub-save]');
        if (saveEl) {
            if (plan.save > 0) {
                saveEl.hidden = false;
                saveEl.textContent = 'Save ' + plan.save + '% today';
            } else {
                saveEl.hidden = true;
            }
        }

        var deliveryEl = benefits.querySelector('[data-sub-delivery]');
        if (deliveryEl && plan.months > 0) {
            deliveryEl.hidden = false;
            deliveryEl.textContent = plan.months === 1
                ? 'Delivered every month'
                : ('Delivered every ' + plan.months + ' months');
        }

        var shippingEl = benefits.querySelector('[data-sub-shipping]');
        if (shippingEl) {
            shippingEl.hidden = !plan.freeShip;
        }
    },

    init: function () {
        var _this = this;

        $("body").on("click", ".quantity-wrap .quantity-btn", function (e) {
            e.preventDefault();
            var box = $(this).parent().find("input");
            if($(this).hasClass('min'))
            {
                if($(this).hasClass('zerook'))
                {
                    if (parseInt(box.val()) > 0) box.val(parseInt(box.val()) - 1);
                }else if (parseInt(box.val()) > 1) box.val(parseInt(box.val()) - 1);
            }else
            {
                box.val(parseInt(box.val()) + 1);
            }
            box.trigger("change");
        });

        $('body').on('click', '.product-form .variable',function (e){
            // Let Quick View / Details open the product popup instead of selecting the variant
            if ($(e.target).closest('[data-call-product-popup], .upsell-details').length) return;

            e.preventDefault();
            e.stopPropagation();
            if($(this).hasClass('active')) return;
            var thisform = $(this).parents('.product-form');
            var thisid = $(this).attr('varid');
            var thissellplan = $(this).attr('data-selling-plan')?$(this).attr('data-selling-plan'):"";

            thisform.find('.selling-plan-id').val(thissellplan);

            thisform.find('.variable').removeClass('active');
            $(this).addClass('active');
            // window.history.replaceState({ }, '', '?variant='+thisid);

            var varprice = $(this).parent().find('.var-price').html();
            console.log(varprice);
            thisform.find('.price-replace').html(varprice);
            thisform.find('form input[name="id"]').val(thisid);
            PROJ.pdp.updateCartDetails(thisform[0], thisid);

            if($(this).hasClass('available'))
            {
                thisform.find('button').removeAttr('disabled');
            }else
            {
                thisform.find('button').attr('disabled','');
            }
            if($(this).attr('data-imgvar-id') != "")
            {
                var ind = $('[data-assign-var="'+$(this).attr('data-imgvar-id')+'"]').index();
                $('.acc-gal').find('.gallery-inside').flickity( 'select', ind );
                if($('.sl-main-gal').length) Flickity.data('.sl-main-gal').select(ind);
            }

            var loyal_points = parseInt($(this).attr('data-loypoint'));
            if(loyal_points > 0) $('#loyal-points').text(loyal_points);

            var newUrl = "?variant="+thisid;
            if(thissellplan != "") newUrl = newUrl+= "&selling_plan="+thissellplan;
            window.history.pushState(null, null, newUrl);


        });

        document.querySelectorAll('.opp-wrap .oitem').forEach((item) =>{
            item.addEventListener('click',(e) =>{
                e.preventDefault();
                document.querySelector('.opp-wrap .oitem.active').classList.remove('active');
                document.querySelectorAll('.js-option').forEach(e => e.classList.remove('active'));
                item.classList.add('active');

                const planset = document.querySelector('.'+item.getAttribute('data-link'));
                if(planset)
                {
                    planset.classList.add('active');
                    planset.querySelector('.sub-pro .sl-var').click();

                    $('.sl-product-form').attr('plantype',item.getAttribute('data-link'));

                }


            });
        })


        $('.selling-plan-change').on('change',function(e){
            e.preventDefault();
            $(this).parents('[data-selling-plan]').attr('data-selling-plan',$(this).val());
            var thisform = $(this).parents('.product-form');
            thisform.find('.selling-plan-id').val($(this).val());
            PROJ.pdp.updateSubBenefitsFromPlan(thisform[0], $(this).val());
        });
    }
}
